import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import Loader from "./Loader";
import TextView from "./TextView";

export interface ButtonTextWithLoaderProps extends BaseUIProps {
  key?: string;
  bText?: string;
}

class _ButtonTextWithLoaderState extends ObservableComponent<ButtonTextWithLoaderProps> {
  static defaultProps = { bText: "" };
  public constructor(props: ButtonTextWithLoaderProps) {
    super(props);

    this.initState();
  }
  public get bText(): string {
    return this.props.bText;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.on(["bText"], this.rebuild);
  }
  public componentDidUpdate(prevProps: ButtonTextWithLoaderProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.bText !== this.props.bText) {
      this.fire("bText", this);
    }
  }
  public render(): ReactNode {
    return ui.Row({
      mainAxisAlignment: ui.MainAxisAlignment.center,
      children: [
        Loader({ className: "x53", key: "0" }),
        TextView({ data: this.bText, className: "xda6", key: "1" }),
      ],
      className: ui.join(this.props.className, "ButtonTextWithLoader"),
      ...copyBaseUIProps(this.props),
    });
  }
}
export default function ButtonTextWithLoader(props: ButtonTextWithLoaderProps) {
  return React.createElement(_ButtonTextWithLoaderState, {
    ..._ButtonTextWithLoaderState.defaultProps,
    ...props,
  });
}
